// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"3bc0cff1","455":"4849d507","977":"fa338f2b"}[chunkId] + ".chunk.js";
};